import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  knowMoreLink: {
    id: 'announcements.knowMoreLink',
    defaultMessage: 'Know More'
  },
  videoLink:{
    id: 'announcements.knowMoreLink',
    defaultMessage: ' Watch a quick video'

  },
  dontShowAgain: {
    id: 'announcements.dontShowAgain',
    defaultMessage: "Don't Show this Again"
  },
  ok: {
    id: 'announcements.ok',
    defaultMessage: 'OK'
  },
  noNewAnnouncements: {
    id: 'announcements.noNewAnnouncements',
    defaultMessage: 'No New Announcements!'
  },
  close: {
    id: 'announcements.close',
    defaultMessage: 'Close'
  },
  previous: {
    id: 'announcements.previous',
    defaultMessage: 'Previous'
  },
  next: {
    id: 'announcements.next',
    defaultMessage: 'Next'
  },
  notNowButton: {
    id: 'announcements.notNowButton',
    defaultMessage: 'Not Now'
  },
  finishButton: {
    id: 'announcements.finishButton',
    defaultMessage: 'Finish'
  },
  announcementsSubHeadingId: {
    id: 'announcementsSubHeadingId',
    defaultMessage: 'announcement-popup-title'
  }
});

